<!-- Loader -->
<ng-container *ngIf="loading">
  <div class="spinner">
    <div class="columns">
      <div class="tabs-container">
        <div class="pt-2">
          <div
            class="tabs is-small has-background-white-bis has-text-weight-bold"
          >
            <div class="tabs-wrapper">
              <ul>
                <li class="is-active">
                  <a>
                    <div class="spinner--label"></div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="spinner--label"></div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="spinner--label"></div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="spinner--label"></div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="spinner--label"></div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="card is-shadowless p-8 p-4-mobile is-bordered">
          <div class="columns">
            <div
              class="column is-7-tablet is-8-desktop is-flex is-flex-direction-column is-justify-content-stretch"
            >
              <div class="spinner--label mb-2"></div>
              <div class="spinner--h5 mb-2"></div>
              <div
                class="card is-fullheight is-fullwidth is-flex is-align-items-center is-justify-content-center is-shadowless has-background-white-bis"
              >
                <div class="loader--chart">
                  <div class="dot1"></div>
                  <div class="dot2"></div>
                </div>
              </div>
            </div>
            <div class="column is-5-tablet is-4-desktop">
              <div
                class="card is-fullwidth is-fullheight has-background-white-bis is-shadowless"
              >
                <div class="card-content">
                  <div class="content is-small">
                    <div class="spinner--h5 mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--h6 mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mt-4"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mt-4"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--h6 mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!--top tabs-->
<ng-container *ngIf="layout === 'overview'">
  <div
    *ngIf="!loading && overviewAggregations.length > 1"
  >
    <div class="class tabs is-small has-background-white-bis has-text-weight-bold">
      <ul>

        <li
          *ngFor="let overview of overviews"
          [ngClass]="{
          'is-active': selectedOverview === overview.id
        }"
        >
          <a (click)="changeOverview(overview.id)">
            {{ overview.label }}
          </a>
        </li>

      </ul>
    </div>
  </div>

  <div *ngIf="selectedOverviewAggregation">

    <div class="">
      <div class="is-shadowless p-4 p-4-mobile is-bordered m-0"
           [ngClass]="{'columns': selectedOverview === 'countryCounts'}">
          <div
            class="column"
            [ngClass]="{
              'is-7-tablet is-8-desktop': selectedOverviewAggregation.helpText
            }"
          >
            <app-aggregation-wrapper
              [aggregation]="selectedOverviewAggregation"
              [selectedCountries]="selectedCountries"
              [selectedIncentiveType]="selectedIncentiveType"
              (pieSliceClick)="onPieSliceClick($event)"
            ></app-aggregation-wrapper>
          </div>
          <div
            class="column is-5-tablet is-4-desktop"
            *ngIf="selectedOverviewAggregation.helpText"
          >
            <div
              class="card is-fullwidth is-fullheight has-background-white-bis is-shadowless"
            >
              <div class="card-content">
                <div
                  class="content is-small"
                  [innerHTML]="selectedOverviewAggregation.helpText"
                ></div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- Tabs -->
<ng-container *ngIf="layout === 'tabs'">
  <div
    class="columns m-0"
    *ngIf="!loading && aggregations.length > 1"
  >
    <div
      *ngIf="showFamilyTabs"
      class="tabs is-small has-background-white-bis has-text-weight-bold m-0"
    >
      <ul>

        <li
          *ngFor="let family of families"
          [ngClass]="{
          'is-active': selectedFamily === family.id
        }"
        >
          <a (click)="changeFamily(family.id)">
            {{ family.label }}
          </a>
        </li>

      </ul>
    </div>
  </div>

  <!--    Top tabs-->
  <div class="columns m-0" *ngIf="!loading && selectedAggregation && !showFamilyTabs">
    <div class="tabs-container">
      <div class="m-0">
        <div class="tabs is-small has-background-white-bis has-text-weight-bold">
          <div class="pb-0 tabs-wrapper">
            <ul>
              <li
                *ngFor="let aggregation of aggregations"
                [ngClass]="{
            'is-active': selectedAggregation?.id === aggregation.id
          }"
              >
                <a (click)="selectedAggregation = aggregation">
                  {{ aggregation.label }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Aggregation -->
  <div class="columns m-0" *ngIf="selectedAggregation">
      <div class="tabs-container" *ngIf="showFamilyTabs">
        <div class="m-0">
          <div class="tabs is-small has-background-white-bis has-text-weight-bold">
            <div class="tabs-wrapper pb-0">
              <ul>
                <li
                  *ngFor="let aggregation of filteredAggregations"
                  [class.is-active]="selectedAggregation?.id === aggregation.id"
                  (click)="selectedAggregation = aggregation"
                ><a (click)="selectedAggregation = aggregation">{{ aggregation.label }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
  </div>

  <div class="" *ngIf="selectedAggregation">
    <div class="columns m-0">
      <div class="card column is-shadowless p-8 p-4-mobile is-bordered">
        <div class="columns">
          <div
            class="column"
            [ngClass]="{
              'is-7-tablet is-8-desktop': selectedAggregation.helpText
            }"
          >
            <app-aggregation-wrapper
              [aggregation]="selectedAggregation"
              [selectedFamily]="selectedFamily"
            ></app-aggregation-wrapper>
          </div>
          <div
            class="column is-5-tablet is-4-desktop"
            *ngIf="selectedAggregation.helpText"
          >
            <div
              class="card is-fullwidth is-fullheight has-background-white-bis is-shadowless"
            >
              <div class="card-content">
                <div
                  class="content is-small"
                  [innerHTML]="selectedAggregation.helpText"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- On list view we display all aggregations one below the other -->
<ng-container *ngIf="layout === 'list'">
  <div class="columns" *ngFor="let aggregation of aggregations">
    <div class="column">
      <div class="card is-shadowless p-8 p-4-mobile is-bordered">
        <div class="columns">
          <div
            class="column"
            [ngClass]="{
              'is-7-tablet is-8-desktop': aggregation.helpText
            }"
          >
            <app-aggregation-wrapper
              [aggregation]="aggregation"
              [selectedFamily]="selectedFamily"
            ></app-aggregation-wrapper>
          </div>
          <div
            class="column is-5-tablet is-4-desktop"
            *ngIf="aggregation.helpText"
          >
            <div
              class="card is-fullwidth is-fullheight has-background-white-bis is-shadowless"
            >
              <div class="card-content">
                <div
                  class="content is-small"
                  [innerHTML]="aggregation.helpText"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
